import { Link } from "@tanstack/react-router";
import { IconPeopleCircleLight } from "@wags/ui/central-icons.tsx";
import { Popover, PopoverContent, PopoverTrigger } from "@wags/ui/popover.tsx";
import { cn } from "@wags/ui/ui-utils";
import { useState } from "react";

export type UserMenuProps = {
    className?: string;

    quizSearch?: object;

    hasCompletedQuiz: boolean;

    onSignOut: () => void;
};

export function UserMenu({
    className,
    quizSearch,
    hasCompletedQuiz,
    onSignOut,
}: UserMenuProps) {
    const [open, setOpen] = useState(false);
    const close = () => setOpen(false);
    const itemClassName =
        "flex items-center rounded-nested px-3 py-2.5 text-[14px] font-medium text-doberman-black outline-none transition-colors hover:bg-doberman-black/4 active:bg-doberman-black/6 motion-reduce:transition-none focus-visible:ring-2 focus-visible:ring-labrador-yellow focus-visible:ring-offset-2 focus-visible:ring-offset-true-white";

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <button
                    type="button"
                    aria-label="Account menu"
                    className={cn(
                        "flex size-11 touch-manipulation items-center justify-center rounded-full text-doberman-black/70 outline-none transition-[background-color,color,transform] active:scale-[0.96] motion-reduce:transition-none motion-reduce:active:scale-100 [@media(hover:hover)]:hover:bg-doberman-black/[0.04] [@media(hover:hover)]:hover:text-doberman-black focus-visible:ring-2 focus-visible:ring-labrador-yellow focus-visible:ring-offset-2 focus-visible:ring-offset-maltese-white",
                        className,
                    )}
                >
                    <IconPeopleCircleLight aria-hidden className="size-8" />
                </button>
            </PopoverTrigger>
            <PopoverContent
                align="end"
                sideOffset={8}
                className="w-56 rounded-md border-0 bg-true-white p-1 shadow-elevation-md ring-0"
            >
                <Link to="/profile" onClick={close} className={itemClassName}>
                    Profile
                </Link>
                <Link
                    to="/match"
                    search={quizSearch}
                    onClick={close}
                    className={itemClassName}
                >
                    Matches
                </Link>
                <Link
                    to="/filter-quiz"
                    search={quizSearch}
                    onClick={close}
                    className={itemClassName}
                >
                    {hasCompletedQuiz ? "Retake quiz" : "Take the quiz"}
                </Link>
                <div className="my-1 h-px bg-doberman-black/8" />
                <Link to="/settings" onClick={close} className={itemClassName}>
                    Settings
                </Link>
                <div className="my-1 h-px bg-doberman-black/8" />
                <button
                    type="button"
                    onClick={() => {
                        close();
                        onSignOut();
                    }}
                    className={cn(
                        itemClassName,
                        "w-full text-left text-doberman-black/70",
                    )}
                >
                    Sign out
                </button>
            </PopoverContent>
        </Popover>
    );
}
